import { AutoMap } from "@automapper/classes";
import { MeasureEauDTO } from "./measure-eau.dto";
import { MeasureLingetteDTO } from "./measure-lingette.dto";
import { MeasureMassifDTO } from "./measure-massif.dto";
import { ProcessDTO } from "./process.dto";
import { SamplingPointDTO } from "./sampling-point.dto";
import { UserDTO } from "./user.dto";
import { ZoneDTO } from "./zone.dto";
import { StrategyDTO } from "./strategy.dto";
import { DisponibiliteClientDTO } from "./disponibilite.dto";
import { MesureGenericDTO } from "./mesure-generic.dto";
import { MesureAdductionDTO } from "./mesure-adduction.dto";
import { EElimsJobStatus } from "src/app/domain/enums/elims-job-status";
import { ELIMSJobInfoDTO } from "./elims-job-info.dto";

export class InterventionDTO {

    /** ID SERVER */
    @AutoMap()
    code!: number;
    @AutoMap()
    status!: number;
    @AutoMap()
    comment?: string;
    @AutoMap()
    strategy?: StrategyDTO;
    @AutoMap()
    duration?: number;
    @AutoMap()
    plannedOn!: string;

    @AutoMap()
    mesuresAPTDepose!: number;
    @AutoMap()
    mesuresAPTPose!: number;
    @AutoMap()
    mesuresAVTDepose!: number;
    @AutoMap()
    mesuresAVTPose!: number;
    @AutoMap()
    mesuresOPPose!: number;
    @AutoMap()
    mesuresPDTDepose!: number;
    @AutoMap()
    mesuresPDTPose!: number;

    @AutoMap()
    rush!: boolean;
    @AutoMap()
    requiresMasqueAdduction!: boolean;

    @AutoMap()
    elimsJob: ELIMSJobInfoDTO = new ELIMSJobInfoDTO();

    @AutoMap()
    samplingPoint: SamplingPointDTO = new SamplingPointDTO();
    @AutoMap()
    sampler: UserDTO = new UserDTO();
    @AutoMap()
    contact: UserDTO = new UserDTO();
    @AutoMap(() => [ZoneDTO])
    zoneList: ZoneDTO[] = [];

    @AutoMap(() => [ProcessDTO])
    processList: ProcessDTO[] = [];

    @AutoMap(() => [MeasureEauDTO])
    mesureEauList: MeasureEauDTO[] = [];

    @AutoMap(() => [MeasureMassifDTO])
    mesureMassifList: MeasureMassifDTO[] = [];

    @AutoMap(() => [MeasureLingetteDTO])
    mesureLingetteList: MeasureLingetteDTO[] = [];

    @AutoMap(() => [MesureGenericDTO])
    mesureGeneriqueList: MesureGenericDTO[] = [];
    @AutoMap(() => [MesureAdductionDTO])
    mesureAdductionAirList: MesureAdductionDTO[] = []
    @AutoMap()
    disponibiliteClient?: DisponibiliteClientDTO;

}